module.exports = __webpack_public_path__ + "./fonts/loading_white.c36ad2a345bb7e7a7db6357c81ea21fc.svg";